// custom-ui/PillTabs.tsx
// The shared segmented "pill tabs" control used to switch between sub-views
// within an area (Medarbetare/Inbjudningar, Jobb tabs, Onboarding Program/Moduler).
// Matches the existing scope-toggle styling for one consistent tab treatment.
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface PillTab {
    key: string;
    label: string;
    icon?: LucideIcon;
}

interface PillTabsProps {
    tabs: PillTab[];
    active: string;
    onChange: (key: string) => void;
    className?: string;
}

export const PillTabs: React.FC<PillTabsProps> = ({ tabs, active, onChange, className }) => (
    <div className={cn('inline-flex items-center gap-1 rounded-xl border border-gray-200 bg-gray-50 p-1', className)}>
        {tabs.map((t) => {
            const Icon = t.icon;
            const isActive = t.key === active;
            return (
                <button
                    key={t.key}
                    type="button"
                    onClick={() => onChange(t.key)}
                    className={cn(
                        'flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all',
                        isActive ? 'bg-white text-[#1A4D4F] shadow-sm' : 'text-gray-600 hover:text-gray-900'
                    )}
                >
                    {Icon && <Icon className="w-4 h-4" />}
                    {t.label}
                </button>
            );
        })}
    </div>
);

export default PillTabs;
